import { RiskIncidentOverviewItemWebComponent } from './component/RiskIncidentOverviewItemWebComponent';

export { RiskIncidentOverviewItemWebComponent };
